import { DataTableBase } from '../../../../../../../core/base/components/data-table-base/data-table-base';
import {
  EstablishmentGenericPrestationModel,
  EstablishmentGenericProductModel,
  EstablishmentModel,
} from '../../../../../../../core/models/establishment.model';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeiColumn } from '../../../../../../../core/base/interfaces/fei-column.interface';
import { EstablishmentService } from '../../../establishment.service';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../../../../core/services/auth.service';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Subject } from 'rxjs';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { getPathFromColumns, sortByPath } from '../../../../../../../core/utils/sort.utils';
import { CrudModeEnum } from '../../../../../../../core/base/enum/crud-mode.enum';
import { EstablishmentNeedDeleteComponent } from '../../../modals/establishment-need-delete/establishment-need-delete.component';

@Component({
  selector: 'vex-establishment-details-prestation-needs',
  templateUrl: './establishment-details-prestation-needs.component.html',
  styleUrls: ['./establishment-details-prestation-needs.component.scss'],
})
export class EstablishmentDetailsPrestationNeedsComponent
  extends DataTableBase<EstablishmentModel>
  implements OnInit, OnDestroy
{
  feisColumns: Array<FeiColumn> = [
    { label: '', column: 'selection' },
    {
      label: 'Identifiant',
      column: 'technicalIdentifier',
      propertyDisplay: null,
    },
    { label: 'Libellé', column: 'label', propertyDisplay: null },
    {
      label: 'Catégorie prestation',
      column: 'prestationCategory',
      propertyDisplay: 'prestationCategory.label',
    },
    { label: '', column: 'actions', canUpdate: false, canDelete: true },
  ];

  establishment: EstablishmentModel;
  selectedRowData: EstablishmentGenericPrestationModel[] = [];
  clearSelectedRow = false;

  constructor(
    public service: EstablishmentService,
    public activatedRoute: ActivatedRoute,
    public authService: AuthService,
    private dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.loading = true;
    this.service.entity$.subscribe((establishment: EstablishmentModel) => {
      this.establishment = establishment;
      const paginatedActivity = establishment?.genericPrestations || [];
      this.dataSource = new MatTableDataSource<EstablishmentGenericPrestationModel>(paginatedActivity);
      this.count = establishment?.genericPrestations?.length;
      this.loading = false;
    });
  }

  deleteItem(element: EstablishmentGenericPrestationModel) {
    this.service.getNeedsImpacts(element).subscribe(res => {
      const impacts = res.data;
      this.dialog
        .open(EstablishmentNeedDeleteComponent, {
          data: {
            defaults: this.establishment,
            generic: element,
            dependencies: impacts,
            type: 'prestation',
            mode: CrudModeEnum.Delete,
            name: element.label,
          },
        })
        .afterClosed()
        .subscribe(result => {
          if (result) {
            this.initData();
          }
        });
    });
  }

  selectedRow(event: EstablishmentGenericPrestationModel[]) {
    if (this.clearSelectedRow) {
      this.clearSelectedRow = false;
    }
    this.selectedRowData = event;
  }

  deleteSelected() {
    if (this.selectedRowData.length === 0) {
      return;
    }

    const genericIds = this.selectedRowData.map(item => item._id);

    this.service.deleteGenericPrestationsBatch(this.establishment._id, genericIds).subscribe(() => {
      this.selectedRowData = [];
      this.clearSelectedRow = true;
      this.initData();
    });
  }

  onSearchChange(event: string) {
    const elements = this.establishment.genericPrestations || [];
    const filteredElements = elements.filter(element => {
      return (
        element.label.toLowerCase().includes(event.trim().toLowerCase()) ||
        element.technicalIdentifier.toLowerCase().includes(event.trim().toLowerCase())
      );
    });
    this.dataSource = new MatTableDataSource<EstablishmentGenericProductModel>(filteredElements);
  }

  ngOnDestroy(): void {}

  // Client-side sort reusing shared utils
  sortEvent(event: { active: string; direction: 'asc' | 'desc' | '' }) {
    this.sortField = event.active;
    this.sortOrder = event.direction;

    const path = getPathFromColumns(this.feisColumns as any, event.active);
    const base = this.establishment?.genericPrestations || [];
    const result = event.direction ? sortByPath(base, path, event.direction) : base.slice();
    this.dataSource = new MatTableDataSource<EstablishmentGenericPrestationModel>(result);
  }
}
